<div class="login-container">

    <div class="container">

        <app-header-for-open-pages></app-header-for-open-pages>

        <!-- <div class="row"> -->

            <!-- <div class="col-12"> -->

                <div class="form-inner">

                    <div *ngIf="errorMessage" class="error-date">
                        <div class="text-error text-error_titel">
                            {{errorMessage}}
                        </div>
                    </div>

                    <form class="form-login" #f="ngForm" [formGroup]="authForm" autocomplete="off" (keyup)="loginByEnter($event, f)" >
                    
                        <div class="form-group">
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i octicon="person"></i>
                                    </div>
                                </div> -->
                                <label for="login">Логин <span class="star">*</span></label>
                                <input type="email" placeholder="Введите e-mail" class="form-control"  [ngClass]="{'input-error': errorMessage}" id="login" formControlName="login"><!--class="{{ validatorValue.username }}"-->
                                <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.login">
                                    <div class="hidePass" *ngIf="item.type == 'pattern' && validation('login', item.type)">
                                        <svg-icon src="/assets/images/icons/exclamation-circle.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.login">
                                    <div class="text-error" *ngIf="validation('login', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="form-group">
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i octicon="lock"></i>
                                    </div>
                                </div> -->
                                <label for="password">{{ 'USERS.USERS_EDITOR.PASS' | translate }} <span class="star">*</span></label>
                                <input placeholder="Введите пароль" [type]="showPass ? 'text' : 'password'"  class="form-control" [ngClass]="{'input-error': errorMessage}"  formControlName="password">
                                <button class="hidePass" (click)="password()">
                                        <svg-icon [src]="showPass ? '/assets/images/icons/eye.svg' : '/assets/images/icons/eye-close.svg'" [stretch]="true"
                                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                </button>
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.password">
                                    <div class="text-error" *ngIf="validation('password', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="row custom-control-box">
                            <!-- <div class="col-6">
                                <div class="custom-control custom-checkbox remember-me">
                                    <input type="checkbox" class="custom-control-input" id="rememberMe">
                                    <label class="custom-control-label" for="rememberMe">{{ 'REMEMBER_OR_FORGOT.REMEMBER_ME' | translate }}</label>
                                </div>
                            </div> -->
                            <div class="col-6">
                                <div class="forgot-password">
                                    <a  (click)="forgotPass()">{{ 'REMEMBER_OR_FORGOT.FORGOT_PASS' | translate }}?</a>
                                </div>
                            </div>
                        </div>
                            
                        <button type="button" class="btn btn-primary btn-block" (click)="login(f)" [disabled]="authForm.invalid">{{ 'MENU_UNAUTH_USER.LOGIN' | translate }}</button>
                                
                    </form>

                </div>



            <!-- </div> -->
        <!-- </div> -->

    </div>

</div>

